import GET_ALL_PRODUCTS from "../graphql/allProducts.gql";
import GET_PRODUCTS from "../graphql/allProductsByCardCode.gql";
import { apolloClient } from './apollo'
/**
 * This is only mock api
 */
export function getProducts() {
    return apolloClient.query({
      query: GET_ALL_PRODUCTS,
      fetchPolicy: window.navigator.onLine ? 'network-only' : 'cache-first'
    })
}
export function getProductsByCardCode(cardCode,shippingAddress) {
    return apolloClient.mutate({
        mutation: GET_PRODUCTS,
        variables: {
            cardCode: cardCode,
            shipping: shippingAddress
        }
    })
}
